<template>
  <div class="panorama-modal">
    <iframe 
      src="/panoramas/berliner-zimmer/index.html" 
      width="100%"
      height="800px"
      style="border:none;"
    >
    </iframe>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'modal',
  props: {
    
  },
  data () {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
        
    })
  },
  methods: {
    ...mapActions({
        toggleModal: 'toggleModal'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.panorama-modal {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #fff;
    z-index: 1000;
}
    
</style>
